import { getComponentClasses } from '@99designs/frontend-components/utils/app';
import React, { useRef } from 'react';

export interface FieldProps {
    title?: string | React.ReactElement;
    message?: string | React.ReactElement;
    errorMessage?: string | React.ReactElement;
    variations?: string[];
    children?: React.ReactNode;
}

export function Field({ title, message, errorMessage, variations = [], children }: FieldProps) {
    const idRef = useRef(Math.random().toString(36).substr(2, 10));
    const classes = getComponentClasses('field', variations);
    const [firstChild, ...rest] = React.Children.toArray(children);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const renderFieldInput = (input: any) => {
        return (
            <div className="field__input">
                {input && React.cloneElement(input, { id: idRef.current })}
            </div>
        );
    };

    return (
        <div className={classes} data-field-error={errorMessage}>
            {title && (
                <label className="field__title" htmlFor={idRef.current}>
                    {title}
                </label>
            )}
            {message && (typeof message === 'string' ? <p>{message}</p> : message)}
            {errorMessage && (
                <div className="field__validation field__validation--create">
                    <div className="field__validation__message field__validation__message--create">
                        {errorMessage}
                    </div>
                </div>
            )}
            {renderFieldInput(firstChild)}
            {rest}
        </div>
    );
}
